import { Link } from 'react-router-dom';
import DataStore from 'flux/stores/DataStore.js'

class Footer extends React.Component {
  constructor() {
    super()

    this.state = {

    }
  }

  render() {

    return (
      <footer className="footer">
        <p className="footer__logo">Anderssons Gästhem & Gårdsbageri</p>
        <p className="footer__content">
          Anderssons Gästhem & Gårdsbageri<br/>
          Ravandersgränd 4<br/>
          22270 Eckerö<br/>
          Åland, Finland<br/><br/>

          mail: info@anderssons.ax<br/><br/>

          tel: +358 400 423 482
        </p>
      </footer>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/scripts/components/Footer.js